<div class="licensing-page-header clr-wrapper">
    <div class="licensing-page-header__header">
        <div class="licensing-page-header__header-text">
            <div class="licensing-page-header__status-container">
                <ng-container *ngrxLet="saasStatus$ as saasStatus">
                    <ng-container *ngrxLet="clsStatus$ as clsStatus">
                        <ng-container *ngrxLet="loadingLicenseStatus$ as loadingLicenseStatus">
                            <avi-tooltip-icon-with-content-wrapper
                                shape="circle"
                                size="28"
                                [status]="getLicenseStatusAlertType(saasStatus, clsStatus, loadingLicenseStatus)"
                                [solid]="true"
                                *ngIf="!loadingLicenseStatus; else loadingLicenseStatusSpinner"
                                class="licensing-page-header__saas-status"
                            >
                                {{ getLicenseStatusAlertMessage(saasStatus, clsStatus) | titlecase }}
                            </avi-tooltip-icon-with-content-wrapper>

                            <ng-template #loadingLicenseStatusSpinner>
                                <div class="licensing-page-header__spinner">
                                    <clr-spinner [clrMedium]="true"></clr-spinner>
                                </div>
                            </ng-template>
                        </ng-container>
                    </ng-container>
                </ng-container>
            </div>
            <h2>{{ l10nKeys.licensingLabel | vtranslate }}</h2>
        </div>
        <cds-button
            action="flat"
            (click)="onCogClick()"
            (keydown.enter)="onCogClick()"
        >
            {{ globalL10nKeys.editLabel | vtranslate }}
        </cds-button>
    </div>

    <div class="licensing-page-header__tabs">
        <button
            (click)="tabSelect(licensingTabActions.OVERVIEW)"
            (keydown.enter)="tabSelect(licensingTabActions.OVERVIEW)"
            [class.active]="activeTab === licensingTabActions.OVERVIEW"
            class="licensing-page-header__tab"
            id="licensing-page-overview-tab"
            type="button"
        >
            {{ l10nKeys.overviewTabLabel | vtranslate }}
        </button>
        <button
            (click)="tabSelect(licensingTabActions.TENANT_USAGE)"
            (keydown.enter)="tabSelect(licensingTabActions.TENANT_USAGE)"
            [class.active]="activeTab === licensingTabActions.TENANT_USAGE"
            class="licensing-page-header__tab"
            id="licensing-page-tenant-usage-tab"
            type="button"
        >
            {{ l10nKeys.tenantUsageTabLabel | vtranslate }}
        </button>
    </div>

    <avi-alert-group
        *ngIf="showLicenseInfoAlertMessage"
        alertType="info"
    >
        {{ licenseInfoAlertMessage }}
    </avi-alert-group>
</div>
